// I know we need to standaridise our code comments
// JavaScript function to handle onload events and register functions
document.addEventListener("DOMContentLoaded", function () {
  openButtonMenu();
  //preventDefaultOnClick();
  shiftFocusOnTab();
  addMenuButtonListener();
  // mobile menu accessibility
  setAriaAttributes();
  updateAriaAttributes();
  // click active class toggle on submenu
  //toggleActiveClassOnSubmenus();
  // lets make button menu accessible via tabs
  buttonMenuLastElementTabEventHandler();
  // updated submenu toggle via chevron buttons
  setupChevronSubmenuToggle();
  menuaccessibility();
});

// Function to open mobile menu
function openMobileMenu() {
  // Get the parent of parent of parent div with class 'mobile-menu'
  var mobileMenu = document.querySelector(".mobile-menu");

  // Add 'active' class on the mobile menu
  mobileMenu.classList.add("active");

  // Get the menu button
  var menuButton = document.querySelector(
    ".menu-action-buttons .mobile-menu-opener"
  );

  // Check if the mobile menu is active
  var isActive = mobileMenu.classList.contains("active");

  // Change aria labels for accessibility
  menuButton.setAttribute("aria-haspopup", isActive ? "true" : "false");
  menuButton.setAttribute("aria-expanded", isActive ? "true" : "false");

  // Add focus to the first anchor tag in the 'nav-container' after a delay
  setTimeout(function () {
    var firstAnchorInNavContainer = document.querySelector(".nav-container a");
    if (firstAnchorInNavContainer) {
      firstAnchorInNavContainer.focus();
    }
  }, 100); // specify the delay here
}

// Add event listener to the menu button
function addMenuButtonListener() {
  // Get the menu button
  var menuButton = document.querySelector(
    ".menu-action-buttons .mobile-menu-opener"
  );

  // Check if the menu button exists to handle edge cases
  if (menuButton) {
    // Add event listener to the menu button
    menuButton.addEventListener("click", openMobileMenu);
  } else {
    console.log("Menu button not found");
  }
}

// Function to close mobile menu
function closeMobileMenu() {
  // Get the mobile menu by its class
  var mobileMenu = document.querySelector(".mobile-menu");

  // Check if the mobile menu exists to handle edge cases
  if (mobileMenu) {
    // Remove 'active' class from the mobile menu
    mobileMenu.classList.remove("active");
  }

  // Get the menu button
  var menuButton = document.querySelector(
    ".menu-action-buttons .mobile-menu-opener"
  );

  // Check if the menu button exists to handle edge cases
  if (menuButton) {
    // Change aria labels for accessibility
    menuButton.setAttribute("aria-haspopup", "false");
    menuButton.setAttribute("aria-expanded", "false");
  }
}

// Add event listener to the close button
document
  .querySelector(".mobile-menu-close-button a")
  .addEventListener("click", closeMobileMenu);

function openButtonMenu() {
  // Get the menu button element
  var menuButton = document.querySelector(
    ".button-menu .menu-action-buttons a"
  );
  // Check if the menu button exists to avoid errors
  if (menuButton) {
    // Add a click event listener to the menu button
    menuButton.addEventListener("click", function (event) {
      // Prevent the default action
      event.preventDefault();
      let parent = event.target.parentNode.parentNode.parentNode;
      // Toggle the 'active' class on click
      parent.classList.toggle("active");

      // Check if the menu is now open or closed
      var isOpen = parent.classList.contains("active");

      // Set the ARIA attributes accordingly
      this.setAttribute("aria-expanded", isOpen);
      this.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    });
  }
}

// Function to prevent default action on click
function preventDefaultOnClick() {
  // Select all elements with the class '.menu-item-has-children' inside a 'header'
  var menuItems = document.querySelectorAll(
    "header .menu-item-has-children > a"
  );
  if (!menuItems) {
    return false;
  }
  // Loop through each element
  for (var i = 0; i < menuItems.length; i++) {
    // Add an event listener for the 'click' event
    menuItems[i].addEventListener("click", function (event) {
      // Prevent the default action
      event.preventDefault();
    });
  }
}

// Function to shift focus on Tab key press
function shiftFocusOnTab() {
  // Select the element with the class '.mobile-menu-contact-us'
  var contactUs = document.querySelector(".mobile-menu-contact-us a");
  if (!contactUs) {
    return false;
  }
  // Add an event listener for the 'keydown' event
  contactUs.addEventListener("keydown", function (event) {
    // Check if the 'Tab' key was pressed
    if (event.key === "Tab" || event.keyCode === 9) {
      // Prevent the default action
      event.preventDefault();

      // Select the element with the class '.mobile-menu-close-button a'
      var closeButton = document.querySelector(".mobile-menu-close-button a");

      // Shift the focus to the close button
      closeButton.focus();
    }
  });
}

// Function to set initial ARIA roles and properties
// for mobile menu only
// Function to set initial ARIA roles and properties
function setAriaAttributes() {
  var menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children, .button-menu .menu-item-has-children, .normal-menu .menu-item-has-children, .normal-colored-menu .menu-item-has-children"
  );
  menuItems.forEach(function (item) {
    if (item.querySelector(".sub-menu")) {
      item.setAttribute("aria-haspopup", "true");
      item.setAttribute("aria-expanded", "false");
    }
  });
}

// Function to update ARIA roles and properties on hover and focus
function updateAriaAttributes() {
  var menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children, .button-menu .menu-item-has-children , .normal-menu .menu-item-has-children, .normal-colored-menu .menu-item-has-children"
  );
  menuItems.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      if (item.querySelector(".sub-menu")) {
        item.setAttribute("aria-expanded", "true");
      }
    });
    item.addEventListener("mouseout", function () {
      if (item.querySelector(".sub-menu")) {
        item.setAttribute("aria-expanded", "false");
      }
    });
    item.addEventListener("click", function () {
      if (item.classList.contains("active")) {
        item.setAttribute("aria-expanded", "true");
      } else {
        item.setAttribute("aria-expanded", "false");
      }
    });
    item.addEventListener(
      "focus",
      function () {
        if (item.querySelector(".sub-menu")) {
          item.setAttribute("aria-expanded", "true");
        }
      },
      true
    );
    item.addEventListener(
      "blur",
      function () {
        if (item.querySelector(".sub-menu")) {
          item.setAttribute("aria-expanded", "false");
        }
      },
      true
    );
  });
}

// lets toggle active class on submenus
function toggleActiveClassOnSubmenus() {
  var menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children a"
  );
  menuItems.forEach(function (item) {
    var submenu = item.parentNode.querySelector(".sub-menu");
    if (submenu) {
      item.addEventListener("click", function (event) {
        event.preventDefault();
        // Check if the submenu is currently visible
        var isSubmenuVisible = submenu.style.display === "block";
        // Toggle the visibility of the submenu
        if (item.parentNode.classList.contains("active")) {
          item.parentNode.classList.remove("active");
          item.parentNode.classList.add("not-active");
        } else {
          item.parentNode.classList.remove("not-active");
          item.parentNode.classList.add("active");
        }

        submenu.classList.toggle("active");
        submenu.style.display = isSubmenuVisible ? "none" : "block";
      });
    }
  });
}

// lets make button menu accessible via tabs

function buttonMenuLastElementTabEventHandler() {
  var buttonMenu = document.querySelectorAll(".button-menu .menu-item a");
  if (!buttonMenu) {
    return false;
  }
  var lastButtonMenu = buttonMenu[buttonMenu.length - 1];
  var buttonToOpenMenu = document.querySelector(".menu-action-buttons a");
  if (!buttonToOpenMenu) {
    return false;
  }
  if (!lastButtonMenu) {
    return false;
  }
  lastButtonMenu.addEventListener("keydown", function (e) {
    var key = e.which || e.keyCode;
    if (key === 9) {
      // 9 is the keyCode for the Tab key
      e.preventDefault();
      buttonToOpenMenu.focus();
    }
  });
}


// function setupChevronSubmenuToggle() {
//   const chevronToggles = document.querySelectorAll(".submenu-toggle");

//   chevronToggles.forEach((toggle) => {
//     toggle.addEventListener("click", function (e) {
//       e.preventDefault();
//       const parentItem = this.closest(".menu-item-has-children");
//       const submenu = parentItem.querySelector(".sub-menu");

//       const isExpanded = this.getAttribute("aria-expanded") === "true";

//       // Toggle ARIA attributes
//       this.setAttribute("aria-expanded", String(!isExpanded));
//       this.setAttribute(
//         "aria-label",
//         !isExpanded ? "Collapse submenu" : "Expand submenu"
//       );

//       // Toggle classes
//       parentItem.classList.toggle("active", !isExpanded);
//       submenu.classList.toggle("active", !isExpanded);

//       // Explicitly handle display style
//       submenu.style.display = !isExpanded ? "block" : "none";
//     });
//   });
// }

function setupChevronSubmenuToggle() {
  const chevronToggles = document.querySelectorAll(".submenu-toggle");

  chevronToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      // e.preventDefault();

      const clickedItem = this.closest(".menu-item-has-children");
      const clickedSubmenu = clickedItem.querySelector(".sub-menu");
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      // Close all menus EXCEPT:
      // - The clicked item
      // - Any parent or child that has `.active`
      document.querySelectorAll(".menu-item-has-children").forEach((item) => {
        // Skip the clicked item and any `.active` parent/child
        if (item !== clickedItem && !item.contains(clickedItem) && !clickedItem.contains(item)) {
          item.classList.remove("active");
          const submenu = item.querySelector(".sub-menu");
          const toggleBtn = item.querySelector(".submenu-toggle");
          if (submenu) {
            submenu.style.display = "none";
            submenu.classList.remove("active");
          }
          if (toggleBtn) {
            toggleBtn.setAttribute("aria-expanded", "false");
            toggleBtn.setAttribute("aria-label", "Expand submenu");
          }
        }
      });

      // If submenu is already expanded AND it has an active child, don't close it
      const hasActiveChild = clickedSubmenu.querySelector(".active");

      if (isExpanded && hasActiveChild) {
        // Do nothing — keep it open
        return;
      }

      // Toggle clicked submenu
      const shouldExpand = !isExpanded;

      this.setAttribute("aria-expanded", String(shouldExpand));
      this.setAttribute("aria-label", shouldExpand ? "Collapse submenu" : "Expand submenu");
      clickedItem.classList.toggle("active", shouldExpand);
      clickedSubmenu.classList.toggle("active", shouldExpand);
      clickedSubmenu.style.display = shouldExpand ? "block" : "none";
    });
  });

  // Optional: Disable submenu link clicks
  const submenuLinks = document.querySelectorAll(".sub-menu a");
  submenuLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      // e.preventDefault(); // Remove this if links should work
    });
  });
}


// mobile-menu-close-button
function menuaccessibility() {
  const menuItems = document.querySelectorAll('.mobile-menu .menu-main-menu-container a');
  const closeBtn = document.querySelector('.mobile-menu-close-button a');

  if (!menuItems.length || !closeBtn) return;

  const lastItem = menuItems[menuItems.length - 1];

  lastItem.addEventListener('keydown', function (e) {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      closeBtn.setAttribute("tabindex", "0");
      closeBtn.focus();
    }
  });
}